﻿<template>
  <section class="small-12 medium-12 large-6 columns">
    <h1 v-html="vueModel.ContentViewModel.Step2Pet.StepTitle" />

    <article>
      <h3 v-html="vueModel.ContentViewModel.Step2Pet.ErrorMessageClaimEventDescription" />

      <div class="control">
        <Field
          as="textarea"
          v-model="vueModel.CreateClaimEntity.ClaimEventDescription"
          rules="required"
          cols="30"
          rows="3"
          name="describe-incident"
          :label="vueModel.ContentViewModel.Step2Pet.ErrorMessageClaimEventDescription"
        />
        <ValidationError name="describe-incident" />
      </div>

      <h3
        data-test-upload-photo-title
        v-html="vueModel.ContentViewModel.GeneralContent.TitleAttachPhotos"
      />

      <p
        data-test-upload-photo-text
        v-html="vueModel.ContentViewModel.GeneralContent.TextAttachPhotos"
      />

      <upload
        v-model="vueModel.files"
        :content="vueModel.ContentViewModel.Step4Shared"
        :title="vueModel.ContentViewModel.GeneralContent.SubtitleAttachPhotos"
      />
    </article>
    <!------------- Questionnaire -->
    <article v-if="hasQuestionnaireQuestions">
      <questionnaire :options="questions" />
    </article>
    <article v-if="stepModel.ProductSpecific.AskForInsuredCounterParty">
      <injured-counterparty
        id="injured-counter-party"
        v-model="vueModel.CreateClaimEntity.ProductSpecific.InjuredCounterParty"
        :content="vueModel.ContentViewModel.Step2Pet"
        :step-model="stepModel"
        data-test-injured-counter-party
        :errors="errors"
      />
    </article>
  </section>
</template>
<script>
import ValidationError from '@/components/UI/ValidationError.vue';
import Upload from '../../components/Upload.vue';
import InjuredCounterparty from '../../components/InjuredCounterparty.vue';
import ReportClaimMixin from '@/components/Feature/Claims/flows/ReportClaimMixin.vue';
import ReportClaimServicesMixin from '@/components/Feature/Claims/flows/ReportClaimServicesMixin.vue';

export default {
  name: 'ReportClaimPetStep2',
  components: { ValidationError, Upload, InjuredCounterparty },
  mixins: [ReportClaimMixin, ReportClaimServicesMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      stepModel: this.vueModel.CreateClaimStep2Model
    };
  }
};
</script>
